import React, { FC, Fragment, Suspense, useEffect, useState } from "react";
import { Route, RouteComponentProps, Switch, useHistory } from "react-router-dom";
import { Navigator } from "../components";
import { UserHead } from "../components/head";
import { MainService } from "../services/main";
import { useSelector } from "../store";
import { Icon } from "../modules";
import { Routes } from "../AppRoutes";
import { ErrorBoundary } from "../components/error-boundary";

export interface IPageProps extends RouteComponentProps {
  user: any;
}

const PageContentFallback = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShow(true), 250);
    return () => clearTimeout(timer);
  }, []);

  if (!show) return null;

  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: 200, height: "100%" }}>
      <Icon.Loading />
    </div>
  );
};

export const AppShell: FC = () => {
  const user = useSelector((state) => state.user);
  const serverTime = useSelector((state) => state.main.serverTime);
  const userPageInitializeStatus = useSelector((state) => state.main.userPageInitializeStatus);
  const history = useHistory();

  useEffect(() => {
    if (userPageInitializeStatus === "pending") MainService.initialUserPage();
    if (userPageInitializeStatus === "completed") {
      if (!user) {
        localStorage.setItem("auth-redirect-to", window.location.pathname);
        history.push("/authentication/login");
      }
    }
  }, [user, userPageInitializeStatus, history]);

  if (user && userPageInitializeStatus === "completed" && serverTime)
    return (
      <Fragment>
        <div className="UserWraper">
          <Navigator />
          <UserHead />

          <div className="content pdb16 pdl32 pdr32">
            <ErrorBoundary>
              <Suspense fallback={<PageContentFallback />}>
                <Switch>
                  {Object.values(Routes).map((item: any, key) => {
                    return (
                      <Route
                        key={key}
                        exact
                        path={item.path}
                        render={(props) => <item.component {...props} user={user} />}
                      />
                    );
                  })}
                </Switch>
              </Suspense>
            </ErrorBoundary>
          </div>
        </div>
      </Fragment>
    );

  return (
    <div className="UserWraper loading">
      <div className="loading">
        {/* <img src="/assets/images/logo-symbol-white.png" alt="" className="logo" /> */}
      </div>
    </div>
  );
};
